import { z } from 'zod'

/**
 * Where an agent-dispatched editor command should act relative to its anchor
 * block. Stale-resilient: anchors reference a `block.id`, not a Slate path.
 *
 * Lives in @tunasong/schemas (not plugin-lib) so server-runtime packages —
 * @tunasong/agent-tools, @tunasong/agent-runtime, backend/ai-api — can read
 * the schema without pulling Plate/Slate/React. The registry implementation
 * (registerAgentCommand, getCommandSpec) still lives in @tunasong/plugin-lib.
 */
export const anchorPositions = ['before', 'after', 'inside-start', 'inside-end', 'replace'] as const
export type AnchorPosition = (typeof anchorPositions)[number]

export const commandAnchorSchema = z.object({
  id: z.string().min(1).describe('Stable block.id of the target.'),
  position: z.enum(anchorPositions).describe('Where to act, relative to the anchor block.'),
  subPath: z
    .array(z.number().int().nonnegative())
    .describe('Optional Slate sub-path within the anchor block. Used for inside-* positions.')
    .optional(),
})
export type CommandAnchor = z.infer<typeof commandAnchorSchema>
